<template>
    <div class="app-digi">
        <div class="horizontal-layout-1 d-flex justify-content-center align-items-center" v-if="loadingGif">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
        </div>
        <div class="horizontal-layout-1" v-else-if="register || !otpVerified">
            <main id="main" class="chrome">
                <router-view />
            </main>
        </div>
        <div class="horizontal-layout-1" v-else>
            <main id="main" class="chrome" v-if="isChrome && loggedIn && otpVerified && registered">
                <div class="nav-menu-block">
                    <div class="digitop">
                        <navbar></navbar>
                    </div>
                </div>
                <div class="digicontainer">
                    <div class="dccontainer">
                        <section class="ps-container w-100 ps ps--theme_default">
                            <!-- <VuePerfectScrollbar class="w-100" :settings="settings" @ps-scroll-y="scrollHanle"> -->
                            <div class="bigcontainer" ref="containerDiv">
                                <div class="content-block">
                                    <div class>
                                        <router-view />
                                    </div>
                                </div>
                                <footerr></footerr>
                            </div>
                            <!-- </VuePerfectScrollbar> -->
                        </section>
                    </div>
                </div>
            </main>
            <main id="main" class="chrome" v-if="isChrome && !loggedIn">
                <div class="digitop">
                    <nav-top></nav-top>
                </div>
                <div class="digicontainer">
                    <div class="dccontainer">
                        <section class="ps-container w-100 ps ps--theme_default">
                            <!-- <VuePerfectScrollbar class="w-100" :settings="settings" @ps-scroll-y="scrollHanle"> -->
                            <div class="bigcontainer" ref="containerDiv">
                                <div class="content-block">
                                    <div class>
                                        <router-view />
                                    </div>
                                </div>
                                <footer-bottom></footer-bottom>
                                <!-- <footerr></footerr> -->
                            </div>
                            <!-- </VuePerfectScrollbar> -->
                        </section>
                    </div>
                </div>
            </main>
            <main id="main" class="chrome" v-if="isChrome && !registered && !account">
                <div class="digitop">
                    <!-- <nav-top></nav-top> -->
                </div>
                <div class="digicontainer">
                    <div class="dccontainer">
                        <section class="ps-container w-100 ps ps--theme_default">
                            <!-- <VuePerfectScrollbar class="w-100" :settings="settings" @ps-scroll-y="scrollHanle"> -->
                            <div class="bigcontainer" ref="containerDiv">
                                <div class="content-block">
                                    <div class>
                                        <register-invited></register-invited>
                                    </div>
                                </div>
                                <footer-bottom></footer-bottom>
                            </div>
                            <!-- </VuePerfectScrollbar> -->
                        </section>
                    </div>
                </div>
            </main>
            <main id="main" class="explorer" v-if="isExplorer" style="background: #ffffff;width: 50%;height: 100%;display: block;margin: 0 auto;flex: none;flex-direction: none;">
                <div class="access-denied-alert">
                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/message.svg" class="img-responsive" alt="IE Not Supported" />
                </div>
            </main>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
    import axios from "axios";
    import Navbar from "./components/Navbar";
    import globals from "./components/globals";
    // import AccountType from "./components/AccountType";
    import Footerr from "./components/Footerr";
    import OtpVerify from "./components/OtpVerify";
    // import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import {
        EventBus
    } from "./components/eventBus/nav-bar-event.js";
    import Loader from "./components/Loader";
    import NavTop from "./components/NavTop";
    import FooterBottom from "./components/FooterBottom";
    import RegisterInvited from "./components/RegisterInvited";
    import Register from "./components/Register";
    import notificationMixin from "./components/mixins/notification";

    import firebase from 'firebase/app';
    import 'firebase/messaging'
    require("firebase/messaging");
    require("firebase/database");
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import user_permission from './components/mixins/user_permission.js';
    export default {
        name: "App",
        components: {
            Navbar,
            Footerr,
            OtpVerify,
            Loader,
            NavTop,
            FooterBottom,
            RegisterInvited,
            Register,
            HalfCircleSpinner,
            SweetModal
        },
        data() {
            return {
                fcmToken: "",
                firebaseServerKey: "AAAAbYnlazc:APA91bHIjq3SWC3cEyTPmxipH3jg_HDG5DDksHOZbpCbi4o9ZxU6Jm259Fdf-URMogP5w_ebYvghDd7HqpPcNZud3FcSqo_RlAK4vK0tsoA0hGxQiktSFFUlrWtmHVf4hsv2hDSUQztZ",
                loadingGif: true,
                isChrome: "chrome",
                isExplorer: "explorer",
                loggedIn: false,
                otpVerified: false,
                registered: true,
                register: false,
                success_msg: '',
                warning_msg: '',
                modules: [],
                module_permissions: [],
                fetch_permissions: [],
                mobileView: false,
            };
        },
        created() {

            // let session_id = sessionStorage.getItem('session_id');
            // if (this.$cookie.get("Token") && session_id) {
            if (this.$cookie.get("Token")) {
                if (this.$route.query.user_id && this.$route.query.secret && this.$route.query.link_for) {
                    this.$router.push(`/user/verify?user_id=${this.$route.query.user_id}&secret=${this.$route.query.secret}&link_for=${this.$route.query.link_for}`);
                }
                else if (this.$route.path == "/register" || this.$route.path == "/login") {
                    this.$router.push("/");
                }
                this.getLoggedInUser();
            } else {
                // sessionStorage.clear();
                // this.$cookie.delete("Token");
                // this.$cookie.delete('Token', {
                //     domain: 'digicollect.com'
                // });
                // this.$cookie.delete('Token', {
                //     domain: 'crm.digicollect.com'
                // });
                this.loadingGif = false;
                this.register = true;
                if (this.$route.query.user_id && this.$route.query.secret && this.$route.query.link_for) {
                    this.$router.push(`/user/verify?user_id=${this.$route.query.user_id}&secret=${this.$route.query.secret}&link_for=${this.$route.query.link_for}`);
                }
                else if (this.$route.query.redirect_to) {
                    this.$router.push("/login?redirect_to=" + this.$route.query.redirect_to);
                } else {
                    this.$router.push("/login");
                }
            }

        },
        mixins:[user_permission,notificationMixin],
        methods: {
            // Geting Logged In User and Set Token
            getLoggedInUser() {
                this.$http.get(globals.AUTH_SERVICE + "/auth/get_loggedin_user?product="+'sales').then(response => {
                    this.loadingGif = false;
                    if (response.data.status_id == 1) {
                        this.loggedIn = true;
                        axios.defaults.headers.common.Authorization = this.$cookie.get("Token");
                        this.$store.commit('setSessionId', response.data.response.session_id)
                        this.$store.commit('setUserId', response.data.response.user_id)
                        // this.registerInterceptors();
                        this.$store.commit("setLoggedInUser", response.data.response);
                        this.loadModules();
                        if (response.data.response.is_verified) {
                            this.otpVerified = true;
                            // this.getUserCompanines();
                        } else {
                            this.$router.push("/verifyOtp");
                        }
                        this.sendNotifications()
                        if (response.data.response.company_id) {
                            this.$store.commit("changeAccountType", true);
                            this.$store.commit("switchAccount", response.data.response.company_id);
                            this.$store.commit("setSelectedCompany", response.data.response);
                            if (response.data.response.is_admin) {
                                this.$store.commit("setAdminSuperAdmin", {
                                    isAdmin: true,
                                    isSuperAdmin: false,
                                });
                            }
                            if (response.data.response.is_superadmin) {
                                this.$store.commit("setAdminSuperAdmin", {
                                    isAdmin: false,
                                    isSuperAdmin: true,
                                });
                            }
                        }
                        if (!(response.data.response.company_details)) {
                            this.$store.commit("changeAccountType", false);
                            this.$store.commit("switchAccount", null);
                            this.$store.commit("setSelectedCompany", response.data.response);
                        }
                        // if (!response.data.response.user_details.is_registered && !this.account) {
                        //     this.registered = false;
                        // }
                    } else {
                        this.$store.commit("setLoggedInUser", null);
                        this.loggedIn = false;
                        let routePath = this.$route.path.split("/")[1];
                        switch (routePath) {
                            case "register":
                            case "registerInvited":
                                break;
                            default:
                                window.location.href = globals.CRM_URL;
                        }
                    }
                }).catch(error => {
                    if (error.response.status == 403 || error.response.status == 400 || error.response.status == 401 || error.response.status == 402) {
                        EventBus.$emit("access_status",'true')
                    } else {
                        EventBus.$emit("access_status",'false')
                    }
                    this.$cookie.delete("Token", {
                        domain: "digicollect.com",
                    });
                    var res = document.cookie;
                    var multiple = res.split(";");
                    for(var i = 0; i < multiple.length; i++) {
                        var key = multiple[i].split("=");
                        document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
                    }
                    setTimeout(() => {
                        window.location.href = globals.CRM_URL + '/login';
                    }, 500);   
                });
            },
            subscribeTokenToTopic(token) {
                fetch('https://iid.googleapis.com/iid/v1/'+this.fcmToken+'/rel/topics/'+this.user_id, {
                    method: 'POST',
                    headers: new Headers({
                    'Authorization': 'key='+this.firebaseServerKey
                    })
                }).then(response => {
                    if (response.status < 200 || response.status >= 400) {
                    throw 'Error subscribing to topic: '+response.status + ' - ' + response.text();
                    }
                }).catch(error => {
                })
            },
            async unSubscribeTokenToTopic(token) {
                let params = {
                    "to": `/topics/${this.user_id}`,
                    "registration_tokens": [this.fcmDetails.fcm_token]
                }
                fetch('https://iid.googleapis.com/iid/v1:batchRemove',{
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': 'key='+this.fcmDetails.fcm_server_key
                    }),
                    body: JSON.stringify(params)
                }).then(response => {
                    if (response.status < 200 || response.status >= 400) {
                    throw 'Error subscribing to topic: '+response.status + ' - ' + response.text();
                    }
                }).catch(error => {
                })
            },
            async sendNotifications() {
                const config = {
                    apiKey: "AIzaSyBWEqLS-P6JjwKcisUYNAgZmpcL--u09qA",
                    authDomain: "digicrm-8aea4.firebaseapp.com",
                    databaseURL: "https://digicrm-8aea4.firebaseio.com",
                    projectId: "digicrm-8aea4",
                    storageBucket: "digicrm-8aea4.appspot.com",
                    messagingSenderId: "470464949047",
                    appId: "1:470464949047:web:50022a33345733340a88b2",
                    measurementId: "G-H2W1YNW57V"
                };
                let fire = firebase.initializeApp(config);

                const messaging = firebase.messaging();
                navigator.serviceWorker.register('/static/firebase-messaging-sw.js')
                .then(async (registration) => {
                    messaging.useServiceWorker(registration);

                    // Request permission and get token.....
                    Notification.requestPermission().then(function(permission) {});
                    try {
                        const oldToken = this.fcmToken;
                        const currentToken = await messaging.getToken({ vapidKey: "BAqQfu09znIYuUNxsjkx3s96hmo0ooPo7vrPAoGqeB0j0iBPSL0iKyOM2BN4bx6VRuAhR9BplPzsPyOgKlXgDHY" });
                        this.fcmToken = currentToken;
                        let param = {
                            fcm_token: this.fcmToken,
                            fcm_server_key: this.firebaseServerKey
                        }
                        this.$store.commit('setFCMDetails', param)
                        if (oldToken != this.fcmToken) {
                        axios.put(globals.ADMIN_API + "/internal/fcm/token", { token: this.fcmToken, session_id: this.session_id })
                            .then(res => {
                            if (res.data.status_id == 1) {
                                // if(this.loggedInUser.role != 'default_order_receiver'){
                                    this.subscribeTokenToTopic()
                                // }
                                // let is_b2c_flow = localStorage.getItem('is_b2c');
                                // console.log("is_b2c_flow", is_b2c_flow)
                                // if(is_b2c_flow == 'false' || is_b2c_flow == false){
                                //     this.subscribeTokenToOrder();
                                // }
                            }
                            })
                            .catch(err => {
                            });
                            if(this.loggedInUser.user_role == 'owner' && !this.mobileView){
                                this.subscribeTokenToTopic()
                            }
                            // let is_b2c_flow = localStorage.getItem('is_b2c');
                            // console.log("is_b2c_flow", is_b2c_flow)
                            // if(is_b2c_flow == 'false' || is_b2c_flow == false){
                            //     this.subscribeTokenToOrder();
                            // }
                        }
                    } catch (err) {
                    }
                });
                messaging.onMessage(async payload => {
                    let body = payload.data
                    EventBus.$emit('RecallNotifications')
                    this.$toasted.show(payload.notification.title,{
                        theme: "toasted-primary",
                        position: "top-center",
                        className: "fw-600",
                        duration: 5000,
                        action : {
                            text: 'Click',
                            onClick : async () => {
                                if(body.goto == 'reminder'){
                                    let res = await this.MarkAsRead({
                                        id: body.reminder_id
                                    })
                                    this.$router.push({
                                        path: '/notifications',
                                        query: {
                                            note_details: body 
                                        }
                                    })
                                    EventBus.$emit('ReloadNotificationToasted', body)
                                }
                            }
                        }
                    })
                })
                const vm = this;
                messaging.onTokenRefresh().then(async function(permission) {
                    const refreshedToken = await messaging.getToken();
                    vm.fcmToken = refreshedToken;
                });
            },
            // registerInterceptors() {
            //     this.$http.interceptors.request.use(
            //         config => {
            //             if (this.$cookie.get('Token')) {
            //                 config.headers.common.Authorization = this.$cookie.get(
            //                     'Token'
            //                 )
            //             }
            //             return config
            //         },
            //         error => {
            //             return Promise.reject(error)
            //         }
            //     )
            //     this.$http.interceptors.response.use(undefined, err => {
            //         if(err.response.status == '403') {
            //             var res = document.cookie;
            //             var multiple = res.split(";");
            //             for(var i = 0; i < multiple.length; i++) {
            //                 var key = multiple[i].split("=");
            //                 document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
            //             }
            //             console.log("load test pos 2")
            //             setTimeout(() => {
            //                 window.location.href = globals.CRM_URL + '/login';
            //             }, 500);
            //         } else if(err.response.status == '400') {
            //             this.$toasted.global.error(err.response.reason)
            //         }else {
            //             this.$log.error(err)
            //         }
            //     })
            // },
            getCallReportType() {
                this.$http.get("/call_report/get_call_report_category").then(res => {
                    if (res.data.status_id == 1) {
                        this.$store.commit("setCallReportType", res.data.response.value);
                    }

                });
            },
            // Getting User Companies
            // getUserCompanines() {
            //     this.$http.get("/employees/get_user_companies").then(res => {
            //         if (res.data.status_id == 1) {
            //             this.$store.commit("setUserAccounts", res.data.response);
            //         }
            //     });
            // },
            async goToSharedContact() {
                let res = await this.$http.get("/contacts/shared_contact_details?id=" + this.$route.query.id);
                if (res.data.status_id == 1) {
                    this.$router.push("/viewcontact/" + this.$route.query.id);
                } else {
                    this.$router.push("/");
                }
            },
            async getUserPermissionData() {
                this.loadingGif = true;
                // let response = await this.getUserPermittedCheckbox();
                // this.module_permissions = response.response
                let module_permit = []
                this.fetch_permissions.forEach(y => {
                    module_permit.push(y)
                })
                this.fetch_permissions.forEach(y => {
                    module_permit.forEach(x => {
                        if((x.sub_module == y.sub_module) && (x.module == y.module)){
                            x['permitted_actions'] = {
                                create: y.permitted_actions.includes('create') ? y.actions.create : false,
                                delete: y.permitted_actions.includes('delete') ? y.actions.delete : false,
                                edit: y.permitted_actions.includes('edit') ? y.actions.edit : false,
                                view: y.permitted_actions.includes('view') ? y.actions.view : false,
                                archive: y.permitted_actions.includes('archive') ? y.actions.archive : false,
                                retrieve: y.permitted_actions.includes('retrieve') ? y.actions.retrieve : false,
                                convert: y.permitted_actions.includes('convert') ? y.actions.convert : false,
                                qualify: y.permitted_actions.includes('qualify') ? y.actions.qualify : false,
                                closed_deal: y.permitted_actions.includes('closed_deal') ? y.actions.closed_deal : false,
                                clone: y.permitted_actions.includes('clone') ? y.actions.clone : false,
                                send: y.permitted_actions.includes('send') ? y.actions.send : false,
                                approval: y.permitted_actions.includes('approval') ? y.actions.approval : false
                            }
                        }
                    })
                })
                //console.log(module_permit)
                let permissions = {}
                module_permit.forEach(x => {
                    if(x.module == 'contacts' && x.sub_module == 'business'){
                        permissions['contacts_business'] = x
                    }
                    else if(x.module == 'contacts' && x.sub_module == 'personal'){
                        permissions['contacts_personal'] = x
                    }
                    else if(x.module == 'company_profile'){
                        permissions['company_profile'] = x
                    }
                    else if(x.module == 'products'){
                        permissions['products'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'campaigns'){
                        permissions['campaigns'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'customers'){
                        permissions['customers'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'deals'){
                        permissions['deals'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'leads'){
                        permissions['leads'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'sales_forecast'){
                        permissions['sales_forecast'] = x
                    }
                    else if(x.module == 'settings'){
                        permissions['settings'] = x
                    }
                    else if(x.module == 'survey_forms'){
                        permissions['survey_forms'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'call_reports'){
                        permissions['call_reports'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'draft_call_reports'){
                        permissions['draft_call_reports'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'reminders'){
                        permissions['reminders'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'teams'){
                        permissions['teams'] = x
                    }
                })
                this.$store.commit("setUserPermissions",permissions)
                this.loadingGif = false
                this.$forceUpdate();
            },
            async getPermissionDataUser() {
                // let response = await this.getUserPermittedCheckbox();
                // this.module_permissions = response.response
                let module_permit = []
                this.fetch_permissions.forEach(y => {
                    module_permit.push(y)
                })
                this.fetch_permissions.forEach(y => {
                    module_permit.forEach(x => {
                        if((x.sub_module == y.sub_module) && (x.module == y.module)){
                            x['permitted_actions'] = {
                                create: y.permitted_actions.includes('create') ? y.actions.create : false,
                                delete: y.permitted_actions.includes('delete') ? y.actions.delete : false,
                                edit: y.permitted_actions.includes('edit') ? y.actions.edit : false,
                                view: y.permitted_actions.includes('view') ? y.actions.view : false,
                                archive: y.permitted_actions.includes('archive') ? y.actions.archive : false,
                                retrieve: y.permitted_actions.includes('retrieve') ? y.actions.retrieve : false,
                                convert: y.permitted_actions.includes('convert') ? y.actions.convert : false,
                                qualify: y.permitted_actions.includes('qualify') ? y.actions.qualify : false,
                                closed_deal: y.permitted_actions.includes('closed_deal') ? y.actions.closed_deal : false,
                                clone: y.permitted_actions.includes('clone') ? y.actions.clone : false,
                                send: y.permitted_actions.includes('send') ? y.actions.send : false,
                                approval: y.permitted_actions.includes('approval') ? y.actions.approval : false
                            }
                        }
                    })
                })
                //console.log(module_permit)
                let permissions = {}
                module_permit.forEach(x => {
                    if(x.module == 'contacts' && x.sub_module == 'business'){
                        permissions['contacts_business'] = x
                    }
                    else if(x.module == 'contacts' && x.sub_module == 'personal'){
                        permissions['contacts_personal'] = x
                    }
                    else if(x.module == 'company_profile'){
                        permissions['company_profile'] = x
                    }
                    else if(x.module == 'products'){
                        permissions['products'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'campaigns'){
                        permissions['campaigns'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'customers'){
                        permissions['customers'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'deals'){
                        permissions['deals'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'leads'){
                        permissions['leads'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'sales_forecast'){
                        permissions['sales_forecast'] = x
                    }
                    else if(x.module == 'settings'){
                        permissions['settings'] = x
                    }
                    else if(x.module == 'survey_forms'){
                        permissions['survey_forms'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'call_reports'){
                        permissions['call_reports'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'draft_call_reports'){
                        permissions['draft_call_reports'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'reminders'){
                        permissions['reminders'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'teams'){
                        permissions['teams'] = x
                    }
                })
                this.$store.commit("setUserPermissions",permissions)
                this.$forceUpdate();
            },
            async loadUserPermissions(){
                this.loadingGif = true
                let param = {
                    operation:"actions"
                }
                let response
                if(this.loggedInUser.user_role == 'sales_manager'){
                    response = await this.getUserPermissionsSalesManager(this.loggedInUser.user_role)
                }
                else{
                    response = await this.getUserPermissions(this.loggedInUser.user_role)
                }
                this.fetch_permissions = response.response.permissions
                this.getUserPermissionData()
                this.loadingGif = false
                this.$forceUpdate();
            },
            async loadModules(){
                this.loadUserPermissions()
                //this.getCallReportType()
            },
            async loadData(){
                this.loadPermissions()
            },
            async loadPermissions(){
                let param = {
                    operation:"actions"
                }
                let response
                if(this.loggedInUser.user_role == 'sales_manager'){
                    response = await this.getUserPermissionsSalesManager(this.loggedInUser.user_role)
                }
                else{
                    response = await this.getUserPermissions(this.loggedInUser.user_role)
                }
                this.fetch_permissions = response.response.permissions
                this.getPermissionDataUser()
                this.$forceUpdate();
            },
        },
        mounted() {
            navigator.detectBrowser = (function () {
                var ua = navigator.userAgent,
                    tem,
                    M =
                    ua.match(
                        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
                    ) || [];
                if (/trident/i.test(M[1])) {
                    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                    return "IE " + (tem[1] || "");
                }
                if (M[1] === "Chrome") {
                    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                    if (tem != null)
                        return tem
                            .slice(1)
                            .join(" ")
                            .replace("OPR", "Opera");
                }
                M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
                if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
                return M.join(" ");
            })();
            var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            var str = navigator.detectBrowser;
            var windowNav = window.navigator;
            var isIOSChrome = windowNav.userAgent.match("CriOS");
            var browser = str.substring(0, str.indexOf(" "));
            var version = str.substring(str.indexOf(" "));
            version = version.trim();
            version = parseInt(version);
            this.$store.commit("setCheckBrowser",browser)
            if (
                (browser == "Chrome") ||
                (browser == "Firefox") ||
                (browser == "Safari") ||
                (browser == "Opera") ||
                (browser == "Edge")
            ) {
                this.isChrome = true;
                this.isExplorer = false;
            } else if (browser == "IE") {
                this.isExplorer = true;
                this.isChrome = false;
            } else if (isIOSChrome) {
                this.isChrome = true;
                this.isExplorer = false;
            } else if (iOS == "iPhone") {
                this.isChrome = true;
                this.isExplorer = false;
            }
            EventBus.$on("scrollToTop", () => {
                this.$nextTick(function () {
                    this.$refs.containerDiv.scrollTop = 0;
                });
            });
            window.onpopstate = function (event) {
                let to = window.location.href.split("/");
                if (to[3] === "callreport") {
                    window.history.back();
                }
            };
            if (String(this.$route.path).startsWith('/contacts/sharing/linked_contact')) {
                this.goToSharedContact();
            }
            EventBus.$on("personal_info_data_update", () => {
                setTimeout(() => {
                    this.getLoggedInUser();
                }, 500);
            })
            EventBus.$on("update",() => {
                this.$nextTick(function(){
                    this.$refs.containerDiv.scrollTop = 0;
                })
            })
            // if(this.$route.path != '/login'){
            //     setInterval(async() => {
            //         this.loadData()
            //     }, 20000);
            // }
            EventBus.$on('UnSubscribe', () => {
                this.unSubscribeTokenToTopic();
            })
            EventBus.$on('user_permissions_refresh_api_call', () => {
                this.loadData();
            })
        },
        destroyed() {
            EventBus.$off("scrollToTop");
            EventBus.$off("personal_info_data_update");
        },
        watch: {
            "$route.path": function (path) {
                // if (path == '/verifyOtp' || path == '/login' || path == '/register' || this.$route.path == '/twostepverification') {
                //     document.body.className = "p-0";
                // } else {
                //     document.body.className = "p-4";
                // }
                if (this.$cookie.get("Token") && path == '/register') {
                    this.otpVerified ? this.$router.push("/") : this.$router.push("/verifyOtp");
                }
                if (this.$cookie.get("Token") && path == '/verifyOtp') {
                    this.otpVerified ? this.$router.push("/") : this.$router.push("/verifyOtp");
                }
            },
            $route(to, from) {
                if (to.path != "/register" && from.path == "/login" && !this.$cookie.get("Token")) {
                    this.$router.push("/login");
                }
            },
        },
        computed: {
            session_id() {
                return this.$store.getters.session_id
            },
            user_id() {
                return this.$store.getters.user_id
            },
            fcmDetails() {
                return this.$store.getters.fcmDetails;
            },
            account() {
                return this.$store.state.account;
            },
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            checkBrowser() {
                return this.$store.state.checkBrowser;
            },
        },
    };
</script>

<style>
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }

    .reduceTop {
        padding-top: 10px !important;
        transition: all 0.5s ease;
    }

    .ps {
        position: relative;
        overflow: hidden !important;
        overflow-anchor: none;
        -ms-overflow-style: none;
        touch-action: auto;
        -ms-touch-action: auto;
    }

    .ps {
        -ms-touch-action: auto;
        touch-action: auto;
        overflow: hidden !important;
        -ms-overflow-style: none;
    }

    .ps {
        -ms-touch-action: auto;
        touch-action: auto;
        overflow: hidden !important;
        -ms-overflow-style: none;
    }

    .ps-container {
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue